import paymentWaterfallDetails from "./paymentWaterfallDetails"
export default paymentWaterfallDetails;
